import React from "react";
import "./Why.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGlobe,
  faFlask,
  faSeedling,
  faShieldHalved,
  faUsers,
  faBolt,
} from "@fortawesome/free-solid-svg-icons";
import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";

const features = [
  {
    icon: faGlobe,
    title: "Premium Imported Technology",
    desc: "Advanced imported solutions that improve crop nutrition and maximize productivity.",
  },
  {
    icon: faFlask,
    title: "Water Soluble Fertilizers",
    desc: "Highly soluble fertilizers ensuring better nutrient absorption and healthier crops.",
  },
  {
    icon: faSeedling,
    title: "Specialty Nutrition",
    desc: "Complete plant nutrition for every growth stage with balanced formulations.",
  },
  {
    icon: faShieldHalved,
    title: "Quality Assured",
    desc: "Every product undergoes strict quality checks to deliver consistent performance.",
  },
  {
    icon: faUsers,
    title: "Farmer Support",
    desc: "Dedicated agronomy support helping farmers achieve better yields.",
  },
  {
    icon: faBolt,
    title: "Fast Results",
    desc: "Quick nutrient availability for stronger growth and improved harvest quality.",
  },
];

const Why = () => {
  return (
    <section className="feature_section">
      <div className="container">
        <div className="feature_heading">
          <Common_Title_2 titleText="Why Choose Us" />
        </div>

        <div className="row">
          {features.map((item, index) => (
            <div className="col-lg-4 col-md-6 mb-5" key={index}>
              <div className="feature_item">
                <div className="feature_icon">
                  <FontAwesomeIcon icon={item.icon} />
                </div>

                <div className="feature_content">
                  <h5>{item.title}</h5>
                  <p>{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Why;